import { render, staticRenderFns } from "./TagNumberSelector.vue?vue&type=template&id=5230a33e&scoped=true"
import script from "./TagNumberSelector.vue?vue&type=script&lang=js"
export * from "./TagNumberSelector.vue?vue&type=script&lang=js"
import "./TagNumberSelector.vue?vue&type=style&index=0&id=5230a33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230a33e",
  null
  
)

export default component.exports